import AdminRoutes from './AdminRoutes';
import BrowseRoutes from './BrowseRoutes';
import PublicRoutes from './PublicRoutes';

export default {
  ...AdminRoutes,
  ...BrowseRoutes,
  ...PublicRoutes,
};
